module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGUlEQVQoU2P8f4PhPwMJgHFUAxGhNSJDCQAaoCIVfExy1AAAAABJRU5ErkJggg=="